import React from 'react';

const getCell = (props) => {

    const { day, itemMonth, cellHeight, cellWidth, dateClick } = props;

    const dataStyle = {
        borderRadius: 7,
        color: 'white',
        padding: 5,
        // width: 30,
        marginLeft: 5,
        marginTop: 3
    }

    var renderItems = [];

    const disabled = day.getMonth() !== itemMonth;


    return <div key={`day_${day.getDate()}`}
        style={{ cursor: !disabled && 'pointer', width: cellWidth, minHeight: cellHeight, border: '1px solid black', marginLeft: -1, marginTop: -1 }}
        onClick={() => {
            dateClick && !disabled && dateClick(day);
        }}
    >
        <div style={{ paddingTop: 5, paddingLeft: 5 }}>
            <div style={disabled ? { color: 'lightgrey' } : { fontWeight: 'bold' }}>{day.getDate()}</div>
        </div>
        <div style={{ width: '100%', marginTop: -5 }}>
            <div style={{
                // display: 'table-cell',
                // verticalAlign: 'bottom',
                marginTop: 20
            }}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {day.getMonth() === itemMonth && renderItems.map((ri, i) => <div key={`${i}_${day.getFullYear()}_${day.getMonth()}`}
                        style={{ ...dataStyle, backgroundColor: ri.backgroundColor }} title={ri.title}>
                        ${ri.value}
                    </div>)}
                </div>
            </div>
        </div>
    </div >

};

const getRow = ({ week, itemMonth, cellWidth = 100, cellHeight = 100, dateClick }) => {
    const days = [];

    const start = new Date(week.getTime());

    days.push(new Date(start.getTime()));

    for (var i = 1; i < 7; i++) {
        start.setDate(start.getDate() + 1);
        days.push(new Date(start.getTime()));
    }

    return <div style={{ display: 'flex' }}>
        {days.map((d, i) => <div key={`day_${d.getDate()}`}>{getCell({ day: d, itemMonth, cellHeight, cellWidth, dateClick })}</div>)
        }

    </div >
}

export default (props) => {

    const { date = new Date(2009, 6), dateClick } = props;

    const start = new Date(date.getTime());
    start.setDate(date.getDate() - date.getDay());

    const end = new Date(date.getTime());
    end.setMonth(end.getMonth() + 1);

    function getNextWeek(date) {
        const ret = new Date(date.getTime());
        ret.setDate(ret.getDate() + 7);

        return ret;
    }

    const weeks = [];

    var w = start;

    while (w < end) {
        weeks.push(w);
        w = getNextWeek(w);
    }

    // return <div>d</div>

    return <div style={{ margin: 20 }}>
        <div style={{ fontSize: 14 }}>
            {weeks.map((w, i) => <div key={`week_${i}`}>
                {getRow({ week: w, itemMonth: date.getMonth(), dateClick })}
                {/* {w.toDateString()} */}
            </div>)}
        </div>
    </div>
}


// WEBPACK FOOTER //
// ./src/common/Calendar.js